import { render, staticRenderFns } from "./Chains.vue?vue&type=template&id=dac5033e"
import script from "./Chains.vue?vue&type=script&lang=ts"
export * from "./Chains.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports